// src/config/llmApiConfig.js

const LLM_API_CONFIG = {
  apiEndpoint:
    "https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent",
  apiKey: process.env.REACT_APP_LLM_API_KEY,

  // System prompt stored as a configuration parameter
  systemPrompt: `You are the Island Assets assistant, a helpful AI designed to answer questions about Island Assets, 
    a consultancy focused on delivering exceptional value through bespoke solutions.
    
    Please help users with information about:
    - Mathematics, Data Science & AI solutions
    - Factor Modelling
    - Optimization services
    - Automation capabilities
    - Digital Transformation
    - Forecasting services
    
    If asked about services not offered by Island Assets, politely explain what services we do provide.
    Always be professional, helpful, and concise in your responses.`,

  defaultParams: {
    contents: [], // This will be populated with messages at runtime
    generationConfig: {
      temperature: 0.7,
      maxOutputTokens: 500,
      topP: 1,
    },
    safetySettings: [
      {
        category: "HARM_CATEGORY_HARASSMENT",
        threshold: "BLOCK_MEDIUM_AND_ABOVE",
      },
      {
        category: "HARM_CATEGORY_HATE_SPEECH",
        threshold: "BLOCK_MEDIUM_AND_ABOVE",
      },
      {
        category: "HARM_CATEGORY_SEXUALLY_EXPLICIT",
        threshold: "BLOCK_MEDIUM_AND_ABOVE",
      },
      {
        category: "HARM_CATEGORY_DANGEROUS_CONTENT",
        threshold: "BLOCK_MEDIUM_AND_ABOVE",
      },
    ],
  },

  headers: {
    "Content-Type": "application/json",
    "x-goog-api-key": process.env.REACT_APP_LLM_API_KEY,
  },

  timeout: 30000,
  maxContextLength: 10,
};

export default LLM_API_CONFIG;
